export class Login {
  constructor(
    public email: string,
    public password: string,
    public timer: string,
  ) {}
}
